import React from "react";

import { Maybe, PageBuilderMilestonesFragment } from "types/graphql-types";
import { graphql } from "gatsby";

import { isPresent } from "src/utils/checks";
import Milestones from "components/Miestones/Milestones";
import MilestoneItem from "components/Miestones/MilestoneItem";
import { IconName } from "@silversea-ssc/ui-components-react";

export type PageBuilderMilestonesProps = PageBuilderMilestonesFragment & {
  //
};

const PageBuilderMilestones: React.FC<
  React.PropsWithChildren<PageBuilderMilestonesProps>
> = ({ intro, items = [] }) => {
  const filteredItems = items.filter(isPresent);

  return (
    <React.Fragment>
      <Milestones introText={intro?.localized}>
        {filteredItems.map((i) => (
          <MilestoneItem
            key={i._key}
            title={i.title?.localized}
            description={i.description?.localized}
            icon={i.icon}
            normalIcon={i.normalIcon as Maybe<IconName>}
            customIconUrl={i.customIcon?.asset?.url}
          />
        ))}
      </Milestones>
    </React.Fragment>
  );
};

export default PageBuilderMilestones;

export const fragments = graphql`
  fragment PageBuilderMilestoneItem on SanityMilestoneItem {
    _key
    icon
    normalIcon
    customIcon {
      asset {
        url
      }
    }

    title {
      localized
    }

    description {
      localized
    }
  }
  fragment PageBuilderMilestones on SanityMilestones {
    _key
    sectionLayoutConfig {
      ...SectionLayoutConfig
    }
    intro {
      localized
    }
    items {
      ...PageBuilderMilestoneItem
    }
  }
`;
